import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo";
import { Layout } from "../../../ui/layout";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { yearOptions } from "../../../utils";
import { GetAllNewMeasure, resetGetAllNewMeasureStatus, setGetAllNewMeasureYear } from "../measures/slice";
import { TuttiProvvedimentiList } from "./list";


export function ReportTuttiProvvedimenti() {
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (newMeasureState.getAllNewMeasureStatus === 'successfully') {
            dispatch(resetGetAllNewMeasureStatus())
        }
    }, [newMeasureState.getAllNewMeasureStatus])


    if (newMeasureState.getAllNewMeasureStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Provvedimenti', 'Elenco Completo Provvedimenti']}
            noPaddingLat
            headerLabel="Elenco Completo Provvedimenti"
        >
            <div className="p-4 pb-0">
                <div className="p-0">
                    <div className="flex flex-wrap items-end gap-4">
                        <div className="w-full md:w-[260px]">
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage=""
                                key={newMeasureState.getAllNewMeasureFilters.year || 'default'}
                                placeholder={'Anno'}
                                value={newMeasureState.getAllNewMeasureFilters.year}
                                options={yearOptions}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setGetAllNewMeasureYear(newValue))
                                }}
                            />
                        </div>

                        <div className="flex items-end">
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Cerca"
                                color={"orange"}
                                onClick={() => dispatch(GetAllNewMeasure(newMeasureState.getAllNewMeasureFilters))}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <TuttiProvvedimentiList />
        </Layout>
    )
}